// Module
var code = "<div class=\"list\"></div> <div class=\"hidden-element empty-message\">{{emptyMessage}}</div> <div class=\"addField\"> <a class=\"add btn-flat waves-effect waves-blue\" style=\"display:inline-block\">{{addText}}</a> </div> ";
// Exports
export default code;